import { IIndexable } from '../interfaces';
import iconsData from './icons/icons.json';

export const TABLER_CATEGORIES = ['Devices', 'Design', 'System', 'Vehicles', 'Text', 'Map', 'Symbols', 'Photography', 'Food', 'Arrows', 'Media', 'Sport', 'Health', 'E-commerce', 'Document', 'Numbers', 'Math', 'Brand', 'Nature', 'Buildings', 'Charts', 'Shapes', 'Weather', 'Database', 'Currencies', 'Gender', 'Gestures', 'Letters', 'Communication', 'Mood', 'Zodiac'];

export const getIconsData = () : IIndexable => {
    return iconsData as IIndexable;
};

/**
 * helper: get only relevant data from the tags.json

const getRelevantData = (data: IIndexable) => {

    const obj: any = {};

    for(let [key, value] of Object.entries(data)){
        obj[key] = {
            category: value.category || ''
        };
    }

    console.log(JSON.stringify(obj))
}; */

/**
 * helper: get Tabler categories from the tags.json

const getCategories = (data: IIndexable) => {
    const set = new Set();

    for(let item of Object.values(data)){
        const category = item.category;
        if(!category) continue;
        set.add(category)
    }

    console.log(Array.from(set));
}; */
